<template>
  <v-container fluid class="fixed-header px-0 py-0">
    <v-main class="px-0 py-0 px-sm-12 py-sm-6">
      <v-row justify="center">
        <v-col>
          <!-- Desktop app bar-->
          <v-app-bar
            id="app-bar-1"
            color="background"
            class="px-0 d-none d-sm-flex"
          >
            <div class="no-overflow">
              <v-img
                alt="GML Logo"
                class="shrink mt-1"
                contain
                :src="require('../assets/images/gml-logo.png')"
                width="70px"
                height="60px"
              />
            </div>
            <div class="logo-name no-overflow ml-3">
              <p v-if="animationDelay > 0.2" class="dosis slide-in-left">GREENMASTERS LIMITED</p>
            </div>

            <v-toolbar-items>
              <v-btn class="d-none d-lg-flex" to="/">
                <v-icon color="gmBlue">mdi-home</v-icon>
                <p class="dosis btn-text"> Home</p>
              </v-btn>

              <v-btn class="d-none d-lg-flex" to="/services">
                <v-icon color="gmBlue">mdi-cogs</v-icon>
                <p class="dosis btn-text">Services</p>
              </v-btn>

              <v-btn class="d-none d-lg-flex" to="/about">
                <v-icon color="gmBlue">mdi-account-hard-hat</v-icon>
                <p class="dosis btn-text">About Us</p>
              </v-btn>

              <v-btn class="d-none d-lg-flex" to="/projects">
                <v-icon color="gmBlue">mdi-excavator</v-icon>
                <p class="dosis btn-text">Projects</p>
              </v-btn>

              <v-btn class="d-none d-lg-flex" to="/policy">
                <v-icon color="gmBlue">mdi-information</v-icon>
                <p class="dosis btn-text">Policy</p>
              </v-btn>

              <v-btn class="d-none d-lg-flex">
                <a href="tel:08037208821" class="no-underline">
                  <v-icon color="gmBlue">mdi-phone</v-icon>
                  <p class="dosis btn-text">Call us</p>
                </a>
              </v-btn>

              <v-btn class="d-none d-lg-flex">
                <a href="mailto:greenmasterslimited@gmail.com" class="no-underline">
                  <v-icon color="gmBlue">mdi-email-send</v-icon>
                  <p class="dosis btn-text">Email us</p>
                </a>
              </v-btn>

              <v-menu offset-x open-on-hover>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-on="on" v-bind="attrs" class="d-md-flex d-lg-none" id="menu-btn">
                    <v-icon color="gmBlue">mdi-menu</v-icon>
                    <p class="dosis btn-text">Menu</p>
                  </v-btn>
                </template>

                <v-list nav dense>
                  <v-list-item link to="/" color="gmBlue">
                    <v-list-item-avatar>
                      <v-icon>mdi-home</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-action>
                      <v-list-item-subtitle>Home</v-list-item-subtitle>
                    </v-list-item-action>
                  </v-list-item>

                  <v-list-item link to="/services" color="gmBlue">
                    <v-list-item-avatar>
                      <v-icon>mdi-cogs</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-action>
                      <v-list-item-subtitle>Services</v-list-item-subtitle>
                    </v-list-item-action>
                  </v-list-item>

                  <v-list-item link to="/about" color="gmBlue">
                    <v-list-item-avatar>
                      <v-icon>mdi-account-hard-hat</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-action>
                      <v-list-item-subtitle>About Us</v-list-item-subtitle>
                    </v-list-item-action>
                  </v-list-item>

                  <v-list-item link to="/projects" color="gmBlue">
                    <v-list-item-avatar>
                      <v-icon>mdi-excavator</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-action>
                      <v-list-item-subtitle>Projects</v-list-item-subtitle>
                    </v-list-item-action>
                  </v-list-item>

                  <v-list-item link to="/policy" color="gmBlue">
                    <v-list-item-avatar>
                      <v-icon>mdi-information</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-action>
                      <v-list-item-subtitle>Policy</v-list-item-subtitle>
                    </v-list-item-action>
                  </v-list-item>

                  <v-list-item link color="gmBlue">
                    <a href="tel:08037208821" class="no-underline">
                      <v-list-item-avatar>
                        <v-icon>mdi-phone</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-action>
                        <v-list-item-subtitle>Call Now</v-list-item-subtitle>
                      </v-list-item-action>
                    </a>
                  </v-list-item>

                  <v-list-item link color="gmBlue">
                    <a href="mailto:greenmasterslimited@gmail.com" class="no-underline">
                      <v-list-item-avatar>
                        <v-icon>mdi-email-send</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-action>
                        <v-list-item-subtitle>Email Us</v-list-item-subtitle>
                      </v-list-item-action>
                    </a>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-toolbar-items>
          </v-app-bar>

          <!-- Mobile app bar-->
          <v-app-bar
            id="app-bar-2"
            app
            color="background"
            class="px-0 d-flex d-sm-none"
          >
            <div class="logo-name no-overflow">
              <p v-if="animationDelay > 0.2" class="dosis slide-in-left">GREENMASTERS LIMITED</p>
            </div>
            <v-toolbar-items>
              <v-menu offset-x open-on-hover>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-on="on" v-bind="attrs" class="d-md-flex d-lg-none" id="menu-btn">
                    <v-icon color="gmBlue">mdi-menu</v-icon>
                  </v-btn>
                </template>

                <v-list nav dense>
                  <v-list-item link to="/" color="gmBlue">
                    <v-list-item-avatar>
                      <v-icon>mdi-home</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-action>
                      <v-list-item-subtitle>Home</v-list-item-subtitle>
                    </v-list-item-action>
                  </v-list-item>

                  <v-list-item link to="/services" color="gmBlue">
                    <v-list-item-avatar>
                      <v-icon>mdi-cogs</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-action>
                      <v-list-item-subtitle>Services</v-list-item-subtitle>
                    </v-list-item-action>
                  </v-list-item>

                  <v-list-item link to="/about" color="gmBlue">
                    <v-list-item-avatar>
                      <v-icon>mdi-account-hard-hat</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-action>
                      <v-list-item-subtitle>About Us</v-list-item-subtitle>
                    </v-list-item-action>
                  </v-list-item>

                  <v-list-item link to="/projects" color="gmBlue">
                    <v-list-item-avatar>
                      <v-icon>mdi-excavator</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-action>
                      <v-list-item-subtitle>Projects</v-list-item-subtitle>
                    </v-list-item-action>
                  </v-list-item>

                  <v-list-item link to="/policy" color="gmBlue">
                    <v-list-item-avatar>
                      <v-icon>mdi-information</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-action>
                      <v-list-item-subtitle>Policy</v-list-item-subtitle>
                    </v-list-item-action>
                  </v-list-item>

                  <v-list-item link color="gmBlue">
                    <a href="tel:08037208821" class="no-underline">
                      <v-list-item-avatar>
                        <v-icon>mdi-phone</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-action>
                        <v-list-item-subtitle>Call Now</v-list-item-subtitle>
                      </v-list-item-action>
                    </a>
                  </v-list-item>

                  <v-list-item link color="gmBlue">
                    <a href="mailto:greenmasterslimited@gmail.com" class="no-underline">
                      <v-list-item-avatar>
                        <v-icon>mdi-email-send</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-action>
                        <v-list-item-subtitle>Email Us</v-list-item-subtitle>
                      </v-list-item-action>
                    </a>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-toolbar-items>
          </v-app-bar>
        </v-col>
      </v-row>
    </v-main>
  </v-container>
</template>

<script>
export default {
  name: 'navigation',

  data: () => ({
    //
  })
}
</script>

<style scoped>
.fixed-header {
  position: fixed;
  top: 0;
  z-index: 5;
}

.logo-name {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.logo-name p {
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 1.6;
  letter-spacing: 0.25rem;
  margin: 0px;
  color: var(--gm-darkblue);
}

.v-toolbar__items {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

#menu-btn {
  border-top-left-radius: 5rem !important;
  border-bottom-left-radius: 5rem !important;
  transform: translateX(16px)
}

.btn-text {
  padding-left: 4px;
  margin: 0px;
}
</style>
